<template>
  <footer class="footer thin-font">
    <p>
      This is a footer. I´m not sure why they are so needed, but here it goes.
      Please don't steal anything. By the way, if you want to contact me do it
      at
      <a
        href="mailto:unpluggeed@gmail.com"
        style="text-decoration: none; color: white"
        >unpluggeed@gmail.com</a
      >. Watch for the double "ee", the cool one was already taken. (Something
      similar happened on the site's url, did you notice?)
    </p>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  props: {},
};
</script>

<style scoped>
.footer {
  padding-top: 1.5rem;
  text-align: center;
  font-size: 50%;
}
</style>
